// import React, { useCallback, useMemo, useState } from "react";
// import male from "../../assets/images/male.svg";
// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllCategories } from "../../../redux/booking/action";
// import Select from 'react-select';



// const statusOptions = [
//   { value: 0, label: "Not Verified" },
//   { value: 1, label: "Active" },
//   { value: 2, label: "Inactive" },
// ];

// const genderOptions = [
//   { value: 1, label: "Male" },
//   { value: 2, label: "Female" },
//   { value: 3, label: "Unisex" },
// ];

// export default function Filter({
//   openFilter,
//   setOpenFilter,
//   params,
//   setParams,
// }) {
//   const handleClear = useCallback(() => {
//     setParams({
//       status: null,
//       gender: "",
//       search_key: "",
//       page: 1,
//       type: 1
//     });
//   }, [setParams]);

//   useEffect(() => {
//     setParams((prevParams) => ({
//       ...prevParams,
//       page: 1,
//     }));
//   }, [params.gender, params.status, setParams]);



//   const handleChange = useCallback(
//     (category, value) => {
//       setParams((prevParams) => ({
//         ...prevParams,
//         [category]: value,
//       }));
//     },
//     [setParams],
//   );

//   const renderedGenderOptions = useMemo(
//     () =>
//       genderOptions.map((option) => (
//         <div key={option.value} className="gender-label">
//           <input
//             type="radio"
//             name="gender"
//             value={option.value}
//             checked={Number(params.gender) === option.value}
//             onChange={() => handleChange("gender", option.value)}
//             id={`gender${option.value}`}
//           />
//           <label htmlFor={`gender${option.value}`}>
//             <img src={male} alt="" />
//             {option.label}
//           </label>
//         </div>
//       )),
//     [params.gender, handleChange],
//   );

//   const renderedStatusOptions = useMemo(
//     () =>
//       statusOptions.map((option) => (
//         <div key={option.value} className="gender-label">
//           <input
//             type="radio"
//             name="status"
//             value={option.value}
//             checked={params.status !== null && Number(params.status) === option.value}
//             onChange={() => handleChange("status", option.value)}
//             id={`status${option.value}`}
//           />
//           <label htmlFor={`status${option.value}`}>{option.label}</label>
//         </div>
//       )),
//     [params.status, handleChange]
//   );
//   const dispatch = useDispatch();
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   console.log(selectedCategory,"selectedCategory")
//   const categories = useSelector((state) => state.bookingSlice?.getCategoresList)



//   const categoryOptions = categories?.categories?.map(item => ({
//     value: item.id,
//     label: item.title
//   }));
//   const handleChangeCategory = (selected) => {
//     setSelectedCategory(selected);
//   };

//   const [paramsList, setParamsList] = useState({
//     page: 1
//   })
//   useEffect(() => {
//     dispatch(getAllCategories(paramsList));
//   }, [dispatch, paramsList]);

//   return (
//     <>
//       <div className={openFilter ? "filter-cont show" : "filter-cont"}>
//         <div className="d-flex justify-content-between align-items-center filter-sec-cont">
//           <h2>Filter</h2>
//           <button className="btn clear-icon" onClick={handleClear}>
//             All Clear
//           </button>
//         </div>
//         <div className='form-group col-md-6'>
//           <label htmlFor="service_type">Service Type</label>
//           <select
//             id="service_type"
//             name="service_type"
//             className='form-control'
//           >
//             <option value="">Select Service Type</option>
//             <option value="1">Venue</option>
//             <option value="2">Home </option>
//             <option value="3">Both</option>
//           </select>

//         </div>
//         <div className="col-md-6 form-group">
//           <label>Select Category</label>
//           <Select
//             value={selectedCategory}
//             onChange={handleChangeCategory}
//             options={categoryOptions}
//             placeholder="Select Category"
//           />
//         </div>
//         <button className="btn close-icon" onClick={() => setOpenFilter(false)}>
//           <i className="fa fa-times"></i>
//         </button>
//         <div className="filter-sub">
//           <h6>Gender</h6>
//           <div className="input-wrapper">{renderedGenderOptions}</div>
//         </div>
//         <div className="filter-sub">
//           <h6>Status</h6>
//           <div className="input-wrapper">{renderedStatusOptions}</div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useCallback, useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import { getAllCategories } from "../../../redux/booking/action";

const statusOptions = [
  { value: 0, label: "Not Verified" },
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
];

const genderOptions = [
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
  { value: 3, label: "Unisex" },
];

export default function Filter({
  openFilter,
  setOpenFilter,
  params,
  setParams,
}) {
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const categories = useSelector((state) => state.bookingSlice?.getCategoresList);

  const categoryOptions = categories?.categories?.map(item => ({
    value: item.id,
    label: item.title
  }));

  const [paramsList, setParamsList] = useState({
    page: 1,
  });

  useEffect(() => {
    dispatch(getAllCategories(paramsList));
  }, [dispatch, paramsList]);

  const handleChange = useCallback(
    (category, value) => {
      setParams((prevParams) => ({
        ...prevParams,
        [category]: value,
      }));
    },
    [setParams],
  );

  const handleClear = useCallback(() => {
    setParams({
      status: null,
      gender: "",
      search_key: "",
      page: 1,
      service_type: "",
      category_id: "",
    });
    setSelectedCategory(null);
  }, [setParams]);


  const handleServiceTypeChange = useCallback((event) => {
    const value = event.target.value ? Number(event.target.value) : null;
    setParams((prevParams) => ({
      ...prevParams,
      service_type: value,
    }));
  }, [setParams]);

  const handleChangeCategory = (selected) => {
    setSelectedCategory(selected);
    setParams((prevParams) => ({
      ...prevParams,
      category_id: selected ? selected.value : "",
    }));
  };

  const renderedGenderOptions = useMemo(
    () =>
      genderOptions.map((option) => (
        <div key={option.value} className="gender-label">
          <input
            type="radio"
            name="gender"
            value={option.value}
            checked={Number(params.gender) === option.value}
            onChange={() => handleChange("gender", option.value)}
            id={`gender${option.value}`}
          />
          <label htmlFor={`gender${option.value}`}>{option.label}</label>
        </div>
      )),
    [params.gender, handleChange]
  );

  const renderedStatusOptions = useMemo(
    () =>
      statusOptions.map((option) => (
        <div key={option.value} className="gender-label">
          <input
            type="radio"
            name="status"
            value={option.value}
            checked={params.status !== null && Number(params.status) === option.value}
            onChange={() => handleChange("status", option.value)}
            id={`status${option.value}`}
          />
          <label htmlFor={`status${option.value}`}>{option.label}</label>
        </div>
      )),
    [params.status, handleChange]
  );

  useEffect(() => {
    setParams((prevParams) => ({
      ...prevParams,
      page: 1,
    }));
  }, [params.gender, params.status, params.service_type, params.category_id, setParams]);
  return (
    <div className={openFilter ? "filter-cont show" : "filter-cont"}>
      <div className="d-flex justify-content-between align-items-center filter-sec-cont">
        <h2>Filter</h2>
        <button className="btn clear-icon" onClick={handleClear}>
          All Clear
        </button>
      </div>
      <div className="col-md-12">
        <div className="row m-0">
          {/* Service Type Dropdown */}
          <div className="form-group col-md-6">
            <label htmlFor="service_type">Service Type</label>
            <select
              id="service_type"
              name="service_type"
              className="form-control"
              value={params.service_type || ""}
              onChange={handleServiceTypeChange}
            >
              <option value="">Select Service </option>
              <option value="1">Venue</option>
              <option value="2">Home</option>
              <option value="3">Both</option>
            </select>
          </div>

          {/* Category Dropdown */}
          <div className="col-md-6 form-group">
            <label>Select Category</label>
            <Select
              value={selectedCategory}
              onChange={handleChangeCategory}
              options={categoryOptions}
              placeholder="Select Category"
            />
          </div>
        </div>
      </div>
      {/* Gender Options */}
      <div className="filter-sub">
        <h6>Gender</h6>
        <div className="input-wrapper">{renderedGenderOptions}</div>
      </div>

      {/* Status Options */}
      <div className="filter-sub">
        <h6>Status</h6>
        <div className="input-wrapper">{renderedStatusOptions}</div>
      </div>

      <button className="btn close-icon" onClick={() => setOpenFilter(false)}>
        <i className="fa fa-times"></i>
      </button>
    </div>
  );
}

